<login-form *ngIf="LoginService.activeForm === 'login'" loginMessage="Welcome!" loginType="guest" [captcha]="showCaptcha"></login-form>

<forgot-password *ngIf="LoginService.activeForm === 'passwordReset'"></forgot-password>

<registration-form *ngIf="LoginService.activeForm === 'registration'" [captcha]="showCaptcha"></registration-form>
